import { Injectable } from '@angular/core';
import { getRoomUrl } from '@shared/utils/url-builder.utils';
import { Course, ExperienceType } from '@shared/models/course.model';

@Injectable()
export class LinkService {
  constructor(
  ) { }

  public getCourseUrl(course: Course): string {
    const isMulti = course.is_multi ?? false;
    const showPoster = course.properties?.displayPoster  ?? false;
    const enableVersioning = course.properties?.versioningEnabled  ?? false;
    const enableSaveProgression = course.properties?.saveProgressionEnabled  ?? false;
    let conditionalQueryParams = isMulti ? '&presenter=true' : '';
    conditionalQueryParams += enableVersioning ? '&versioned=false' : '';
    conditionalQueryParams += enableSaveProgression ? '&instanced=false' : '';
    const roomUrlRoot = getRoomUrl(course.experience_type);
    return `${roomUrlRoot}?course=${course.id}&poster=${showPoster}${conditionalQueryParams}`;
  }

  public launchCourse(course: Course, openNewTab: boolean = true): void {
    const link = this.getCourseUrl(course);
    if (openNewTab) {
      window.top.open(link);
    } else {
      window.top.location.assign(link);
    }
  }

  public launchCourseById(courseId: string, openNewTab: boolean = true, experienceType?: ExperienceType): void {
    const roomUrlRoot = getRoomUrl(experienceType);
    const link = `${roomUrlRoot}?course=${courseId}&poster=false`;
    if (openNewTab) {
      window.top.open(link);
    } else {
      window.top.location.assign(link);
    }
  }
}
